// @ts-nocheck
import React from 'react';

import { TimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import { FieldProps, Field as FormikField } from 'formik';
import { DateTime } from 'luxon';

export type TTimeFieldProps = TimePickerProps<DateTime | null> & {
	name: string;
	valueFormat?: string;
};

function TimeField({ name, valueFormat, ...props }: TTimeFieldProps) {
	const getTimeValue = (value: DateTime | string | null | undefined) => {
		if (!value || DateTime.isDateTime(value)) {
			return value || null;
		}

		if (typeof value !== 'string') {
			return null;
		}

		const times = [
			valueFormat ? DateTime.fromFormat(value, valueFormat) : null,
			DateTime.fromFormat(value, 'HH:mm'),
			DateTime.fromFormat(value, 'HH:mm:ss'),
		].filter(Boolean);

		return times.find((time) => time.isValid) || null;
	};

	return (
		<FormikField name={name}>
			{({ field, form }: FieldProps) => (
				<TimePicker
					ampm={false}
					value={getTimeValue(field.value)}
					onChange={(newValue) => {
						const value =
							valueFormat && typeof field.value === 'string'
								? newValue?.toFormat(valueFormat) ?? ''
								: newValue;

						form.setFieldValue(name, value);
					}}
					{...props}
				/>
			)}
		</FormikField>
	);
}

export default TimeField;
